import { FirebaseService } from 'src/app/core/services/firebase.service';
import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {LoginService} from '../../core/services/login.service';
import {Router} from '@angular/router';
import {UserService} from '../../core/services/user.service';
import {LogosService} from '../../core/services/logos.service';
import {SessionService} from '../../core/services/session.service';
import jwtDecode from 'jwt-decode';
import { UserRoles } from '../../../models/User';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() clickEmitter = new EventEmitter();
  @Input() user;
  sidebarOpened = false;
  userRolesMap = new Map<UserRoles, string>([ // TODO put this into another file
    [UserRoles.MANAGER, "Gestor"],
    [UserRoles.MASTER, "Master"],
    [UserRoles.ADMIN, "Administrador"],
    [UserRoles.OPERATOR, "Operador"],
  ]);
  imageURL: string;
  profilePictureUrl = '';
  userId = '';

  @HostListener('document:click', ['$event']) public onClick(event: any): void
  {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.sidebarOpened = false;
      event.stopPropagation();
    }
  }

  constructor(private loginService: LoginService,
              private userService: UserService,
              private logoService: LogosService,
              private sessionService: SessionService,
              private router: Router,
              private elementRef: ElementRef,
              private firebaseService: FirebaseService) { }

  ngOnInit(): void {
    this.getTenantId();
    this.getLogo();
    this.getUserProfilePicture();
    this.firebaseService.imageUploaded$.subscribe(uploaded => {
      if (uploaded) {
        this.getUserProfilePicture();
      }
    });
  }

  ngOnDestroy(): void {
    this.firebaseService.imageUploaded$.complete();
    this.firebaseService.imageUploaded$.unsubscribe();
  }

  getTenantId() {
    const session = this.sessionService.getSession();
    const decodedSession: any = jwtDecode(session.accessToken);
    this.userId = decodedSession.userId;
    return decodedSession.tenantId;
  }

  async getLogo() {
    const tenantId = this.getTenantId();
    this.imageURL = await this.logoService.getLogo(tenantId);
  }

  async logout() {
    await this.loginService.logout();
    await this.router.navigate(['/login']);
  }

  toggleSidebar() {
    this.sidebarOpened = !this.sidebarOpened;
    this.clickEmitter.emit(true);
  }

  toDashboard() {
    this.router.navigate(['dashboard']);
  }

  getUserRole(role: UserRoles) {
    return this.userRolesMap.get(role) || '---';
  }

  async getUserProfilePicture() {
    this.profilePictureUrl = await this.firebaseService.getUserPicture(this.userId);
  }
}
